namespace GeniuzPOS.InitialData {
    export namespace PsQRPromptPayService {
        export const baseUrl = 'InitialData/PsQRPromptPay';

        export declare function Create(request: Serenity.SaveRequest<PsQRPromptPayRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsQRPromptPayRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsQRPromptPayRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsQRPromptPayRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "InitialData/PsQRPromptPay/Create",
            Update = "InitialData/PsQRPromptPay/Update",
            Delete = "InitialData/PsQRPromptPay/Delete",
            Retrieve = "InitialData/PsQRPromptPay/Retrieve",
            List = "InitialData/PsQRPromptPay/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsQRPromptPayService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
